import _ from 'underscore';
import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { Select } from '@bingads-webui-react/primitive';

export const DayOfMonth = memo(({
  classNamePrefix,
  cronFormatter,
  onChange,
  selected,
  ariaLabelledby,
}) => {
  const translations = cronFormatter.getDaysOfMonth();

  const [selectedDayOfMonth, setDayOfMonth] = useState(selected);

  return (
    <Select
      className={`${classNamePrefix}__day-of-month`}
      value={selectedDayOfMonth}
      onChange={(event) => {
        const dayOfMonth = parseInt(event.target.value, 10);
        setDayOfMonth(dayOfMonth);
        onChange(dayOfMonth);
      }}
      aria-labelledby={ariaLabelledby}
    >
      {_.range(1, 29).map(dayOfMonth =>
        <option key={dayOfMonth} value={dayOfMonth}>{translations[dayOfMonth]}</option>)}
    </Select>
  );
});

DayOfMonth.propTypes = {
  classNamePrefix: PropTypes.string.isRequired,
  cronFormatter: PropTypes.shape({
    getDaysOfMonth: PropTypes.func,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.number.isRequired,
  ariaLabelledby: PropTypes.string,
};

DayOfMonth.defaultProps = {
  ariaLabelledby: '',
};
